import "./NewPTContent.css";

export default function NewPTContent({ children, className = "", style = {} }) {
    return (
        <div className={`content_descnewpt ${className}`} style={style}>
            {children}
        </div>
    );
}
